module.exports = __webpack_public_path__ + "media/images/writer/monitor/icon-31106f16bf9afe91eb9a6bbb20f631d3.ttf";